import { computed, onMounted, watch } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import type { Member } from '../../../core/models/member/member'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'
import { useRoute } from 'vue-router'
import type { CoachingStatus } from '../../dashboard/composables/useCoachingInvitations'

export const useCoachee = () => {
  const route = useRoute()

  const coacheeId = computed(() => route.params.id as string)

  const endpoint = computed(() => `coaching/coachee/${coacheeId.value}`)

  const { data, load, status, reload } = useGet<Coachee>(endpoint)

  const bus = useEventBus(EventKey.dialogUpdated)
  onMounted(() => load())
  bus.on(() => reload())

  watch(coacheeId, () => {
    load()
  })

  return {
    data,
    status,
  }
}

export interface Coachee {
  readonly member: Member
  readonly status: CoachingStatus
}
